import mustache from "mustache";
import { ISummaryItemRender } from "../../definitions/summary/ISummaryItemRender";
import { SummaryItemConfig } from "../../definitions/summary/SummaryItemConfig";
import template from "./template.html";

mustache.parse(template);

/** Placeholder cuando no hay valor. */
const EMPTY_VALUE = "—";

/** Contador para ids únicos por instancia. */
let SUMMARY_ID = 0;

/** Item de resumen de solo lectura (Render/Connect): ícono opcional, label,
 *  valor destacado y descripción. Valor y descripción se actualizan en vivo
 *  con `setValue`/`setDescription` (null/"" → "—" en el valor). */
export class SummaryItemRender implements ISummaryItemRender {
  /** Id único de la instancia (para los spans de valor/descripción). */
  private readonly _summaryId: number;

  constructor(private readonly _config: SummaryItemConfig) {
    SUMMARY_ID += 1;
    this._summaryId = SUMMARY_ID;
  }

  render(): string {
    return mustache.render(template, {
      id: this._summaryId,
      label: this._config.label,
      description: this._config.description,
      value: this._toDisplay(this._config.value),
      icon: this._config.icon,
    });
  }

  /** Captura el span del valor y de la descripción para actualizarlos en vivo. */
  connect(): void {
    this._valueEl = document.getElementById(`summary-value-${this._summaryId}`);
    this._descEl = document.getElementById(`summary-desc-${this._summaryId}`);
  }

  dispose(): void {}

  /** Actualiza el valor mostrado; null/"" → "—". */
  setValue(value: string | null): void {
    if (this._valueEl) this._valueEl.textContent = this._toDisplay(value);
  }

  /** Actualiza la descripción mostrada. */
  setDescription(description: string): void {
    if (this._descEl) this._descEl.textContent = description;
  }

  private _valueEl: HTMLElement | null = null;
  private _descEl: HTMLElement | null = null;

  /** Normaliza a texto mostrable ("—" si null/vacío). */
  private _toDisplay(value: string | null | undefined): string {
    return value != null && value !== "" ? value : EMPTY_VALUE;
  }
}
